export default {
  state: {
    pointTree: [],
    pointSingle: null,
    pointTypeList: [],
    pointRequestList: [],
    wayList: []
  },
  mutations: {
    setPointTree (state, payload) {
      state.pointTree = payload
    },
    setPointSingle (state, payload) {
      state.pointSingle = payload
    },
    setPointTypeList (state, payload) {
      state.pointTypeList = payload
    },
    setPointRequestList (state, payload) {
      state.pointRequestList = payload
    },
    setWayList (state, payload) {
      state.wayList = payload
    }
  },
  actions: {
    getPointTree ({commit, dispatch}, {q}) {
      const url = '/admin/point/tree?access_token=' + this.getters.accessToken + '&q=' + q
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointTree', data.point_folder_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async getPointFolderList ({commit, dispatch}, {id, mode, channelIdList}) {
      let returnData = {}
      const url = '/admin/point/folder/list?access_token=' + this.getters.accessToken +
        '&point_folder_id=' + id +
        '&distribution_channel_id_list=' + channelIdList +
        '&mode=' + mode
      await dispatch('apiGet', url)
        .then((data) => {
          returnData.point_folder_list = data.point_folder_list
          returnData.point_list = data.point_list
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    deletePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/point/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка удалена успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    activatePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/point/' + id + '/activate?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка восстановлена успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    getPointSingle ({commit, dispatch}, {id}) {
      const url = '/admin/point/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointSingle', data.point)
        })
        .catch((error) => {
          throw error
        })
    },
    getPointTypeList ({commit, dispatch}) {
      const url = '/admin/point/type/list?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointTypeList', data.point_type_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async updatePoint ({commit, dispatch}, updateData) {
      let post = {
        data: updateData,
        url: '/admin/point/' + updateData.id + '/update?access_token=' + this.getters.accessToken
      }

      let returnData = null
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка изменена успешно')
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    getPointRequestList ({commit, dispatch}, {mode}) {
      const url = '/admin/point/request/list?access_token=' + this.getters.accessToken + '&mode=' + mode
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointRequestList', data.point_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getPointRequestLogisticsList ({commit, dispatch}) {
      const url = '/admin/point/request/logistics?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointRequestList', data.point_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getPointRequestSecurityList ({commit, dispatch}) {
      const url = '/admin/point/request/security?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointRequestList', data.point_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getWayList ({commit, dispatch}) {
      const url = '/admin/way/list?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setWayList', data.way_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async logisticsUpdatePoint ({commit, dispatch}, updateData) {
      let post = {
        data: updateData,
        url: '/admin/point/' + updateData.id + '/logistics/update?access_token=' + this.getters.accessToken
      }

      let returnData = null
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка изменена успешно')
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async securityUpdatePoint ({commit, dispatch}, updateData) {
      let post = {
        data: updateData,
        url: '/admin/point/' + updateData.id + '/security/update?access_token=' + this.getters.accessToken
      }

      let returnData = null
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка изменена успешно')
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async securityApprovePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {},
        url: '/admin/point/security/approve?access_token=' + this.getters.accessToken + '&point_id=' + id
      }

      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка согласована')
        })
        .catch((error) => {
          throw error
        })
    },
    async securityDeclinePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {},
        url: '/admin/point/security/decline?access_token=' + this.getters.accessToken + '&point_id=' + id
      }

      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка отклонена')
        })
        .catch((error) => {
          throw error
        })
    },
    async logisticsApprovePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {},
        url: '/admin/point/logistics/approve?access_token=' + this.getters.accessToken + '&point_id=' + id
      }

      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка согласована')
        })
        .catch((error) => {
          throw error
        })
    },
    async logisticsDeclinePoint ({commit, dispatch}, {id}) {
      let post = {
        data: {},
        url: '/admin/point/logistics/decline?access_token=' + this.getters.accessToken + '&point_id=' + id
      }

      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Торговая точка отклонена')
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    pointTree (state) {
      return state.pointTree
    },
    pointSingle (state) {
      return state.pointSingle
    },
    pointTypeList (state) {
      return state.pointTypeList
    },
    pointRequestList (state) {
      return state.pointRequestList
    },
    wayList (state) {
      return state.wayList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/point.js